/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createCopy} from '../api'

export const useMutationCreateCopy = createReactQueryMutationHook('createCopy', createCopy)
